import { webApiEndpoints } from '../config';
import { mapper } from '../helpers/mapper.helper';
import { UserRolType, NavItemDataProps, UserDataPart, UserData, AppCategories, AppRequestType } from '../types'

const category: AppCategories = 'rol'

export const rolesAdapter = {
    getUsers: (): AppRequestType<UserData[]>[typeof category]['getUsers'] => ({
        endpoint: webApiEndpoints[category].getUsers,
        input: null,
        keepCacheBeforeNewRequest: true,
        output: (datos) => datos.map(mapper.apiUser)
    }),
    updateUserDataPart: (item: UserDataPart, idUsuario: number, deleteData?: boolean): AppRequestType<UserDataPart>[typeof category]['updateUserDataPart'] => ({
        endpoint: webApiEndpoints[category][deleteData ? 'deleteUserDataPart' : 'updateUserDataPart'],
        input: ({
            clave: item.code,
            etiqueta: item.label,
            id: item.id,
            orden: item.order,
            valor: item.value
        }),
        parameters: { headers: { idUsuario: String(idUsuario) } },
        output: (datos) => datos
    }),
    setUser: (user: UserData): AppRequestType<UserData>[typeof category]['setUser'] => ({
        endpoint: webApiEndpoints[category].setUser,
        input: ({
            id: user.id || 0,
            nombre: user.name,
            rol: user.rol
        }),
        output: (datos) => mapper.apiUser(datos)
    }),
    getRoles: (): AppRequestType<UserRolType[]>[typeof category]['getRoles'] => ({
        endpoint: webApiEndpoints[category].getRoles,
        input: null,
        output: (datos) => datos.map(mapper.apiRol)
    }),
    updateRol: (rolData: UserRolType, operationType: 'add' | 'update'): AppRequestType<UserRolType[]>[typeof category]['addRol'] => ({
        endpoint: webApiEndpoints[category][operationType === 'add' ? 'addRol' : 'editRol'],
        input: ({
            descripcion: rolData.description,
            id: rolData.id,
            menu: [],
            nombre: rolData.name,
            totalUsuarios: 0
        }),
        output: (datos) => datos.map(mapper.apiRol)
    }),
    addMenu: (idRol: number, data: NavItemDataProps): AppRequestType<NavItemDataProps>[typeof category]['addMenu'] => ({
        endpoint: webApiEndpoints[category].addMenu,
        input: ({
            id: data.id,
            idPadre: data.idRoot || 0,
            nombre: data.label,
            ruta: data.path || '',
            icono: data.icon,
            descripcion: data.description
        }),
        parameters: { headers: { idRol: String(idRol) } },
        output: (datos) => mapper.apiMenu(datos)
    }),
    editMenu: (data: NavItemDataProps): AppRequestType<NavItemDataProps>[typeof category]['editMenu'] => ({
        endpoint: webApiEndpoints[category].editMenu,
        input: ({
            id: data.id,
            idPadre: data.idRoot || 0,
            nombre: data.label,
            ruta: data.path || '',
            icono: data.icon,
            activo: data.active,
            descripcion: data.description
        }),
        output: (datos) => mapper.apiMenu(datos)
    }),
    changeMenuStatus: (idMenu: number): AppRequestType<NavItemDataProps>[typeof category]['changeMenuStatus'] => ({
        endpoint: webApiEndpoints[category].changeMenuStatus,
        input: null,
        parameters: { headers: { idMenu: String(idMenu) } },
        output: (datos) => mapper.apiMenu(datos)
    }),
    deleteMenu: (idMenu: number): AppRequestType<NavItemDataProps>[typeof category]['deleteMenu'] => ({
        endpoint: webApiEndpoints[category].deleteMenu,
        input: null,
        parameters: { headers: { idMenu: String(idMenu) } },
        output: (datos) => mapper.apiMenu(datos)
    }),
    updateRolResources: (idRol: number, itemsResourceMenu: Map<number, number>): AppRequestType<string>[typeof category]['updateRolResources'] => ({
        endpoint: webApiEndpoints[category].updateRolResources,
        input: ({
            idRol,
            recursos: [...itemsResourceMenu.keys()].map(k => ({ idRecurso: k, idMenu: itemsResourceMenu.get(k) || 0 }))
        }),
        output: (datos) => datos
    })
}